import React, {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {NotificationContainer} from 'react-notifications';
import {Route, Switch} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import pagesSaga from 'sagas/foldersSaga';
import {Redirect} from 'react-router';
import {useInjectSaga} from 'utils/injectSaga';
import {fetchFolders} from 'actions/folderActions';
import {makeSelectInitialLoadUserDone} from 'reducers/selectors/userSelectors';
import {loadUserFromLocalStorage} from 'actions/userActions';
import {BASE_DIRECTORY} from 'config';

import LoadingIndicator from 'components/LoadingIndicator';
import NotFoundPage from 'containers/NotFoundPage/Loadable';
import Signing from 'containers/Signing/Loadable';
import PartnerLogin from 'containers/PartnerLogin/Loadable';
import ForgotPassword from 'containers/ForgotPassword/Loadable';
import ResetPassword from 'containers/ResetPassword/Loadable';
import Dashboard from 'containers/Dashboard/Loadable';
import Admin from 'containers/Admin';
import PostCategories from 'containers/Categories/Post/Loadable';
import InformationCategories from 'containers/Categories/Information/Loadable';
import CompanyCategories from 'containers/Categories/Company/Loadable';
import Readers from 'containers/Admin/Users/Readers/Loadable';
import Seller from 'containers/Admin/Users/Seller/Loadable';
import Posts from 'containers/Posts/Loadable';
import Pages from 'containers/Pages/Loadable';
import PreviewPost from 'containers/Posts/Preview/Loadable';
import Company from 'containers/Company/Loadable';
import CreateCompany from 'containers/Company/Create/Loadable';
import EditCompany from 'containers/Company/Edit/Loadable';
import ReaderPosts from 'containers/Reader/Posts';
import ReaderCompany from 'containers/Reader/Company';
import PartnerPage from 'containers/Admin/Users/Loadable';
import CreatePost from 'containers/Posts/Create/Loadable';
import EditPost from 'containers/Posts/Create/LoadableEdit';
import Overview from 'containers/CompanyUser/Overview/Loadable';
import CompanyPosts from 'containers/CompanyUser/Posts/Loadable';
import PostView from 'containers/Posts/View/Loadable';
import Files from 'containers/CompanyUser/File/Loadable';
import Account from 'containers/CompanyUser/Account/Loadable';
import ImportPosts from 'containers/Admin/Import/Loadable';
import PartnerPreview from 'containers/Company/Preview';
import Editor from 'containers/Admin/Users/Editor/Loadable';
import userSaga from 'sagas/userSaga';
import uiStateSaga from 'sagas/uiStateSaga';
import PrivateRoute from './privateRoute';
import 'styles/index.scss';
import 'react-notifications/lib/notifications.css';
import competitionSaga from '../../sagas/competitionSaga';
import {fetchCompetitions} from '../../actions/competitionActions';
import JudgePage from '../Admin/Users/Judge/Loadable';

const initialLoadUserDoneSelector = makeSelectInitialLoadUserDone();

export default function App() {
  useInjectSaga({key: 'user', saga: userSaga});
  useInjectSaga({key: 'uiState', saga: uiStateSaga});
  useInjectSaga({key: 'pages', saga: pagesSaga});
  useInjectSaga({key: 'competition', saga: competitionSaga});

  const dispatch = useDispatch();
  const initialLoadUserDone = useSelector(initialLoadUserDoneSelector);

  // const userDetails = useSelector(basicUserSelector);
  useEffect(() => {
    dispatch(loadUserFromLocalStorage());
    dispatch(fetchFolders());
    dispatch(fetchCompetitions());
  }, []);
  useEffect(() => {
    // console.log(userDetails);
    // if(userDetails && isJudge(userDetails.roles))
    //     dispatch(fetchCompetitions());
  }, [initialLoadUserDone]);

  // useEffect(() => {
  //     console.log(competition);
  //     if (  competition && competition.current) {
  //         history.push(`/posts/${competition.current._id}/architecture`);
  //     }
  //
  // }, [competition]);
  const judgePath = `${BASE_DIRECTORY}/judge`;
  return (
    <div className="app-wrapper">
      <NotificationContainer />
      <Helmet titleTemplate="%s - JIDIPI" defaultTitle="JIDIPI">
        <meta name="description" content="JIDIPI - Blogs" />

        <meta httpEquiv="cache-control" content="max-age=0" />
        <meta httpEquiv="cache-control" content="no-cache" />
        <meta httpEquiv="expires" content="0" />
        <meta httpEquiv="expires" content="Tue, 01 Jan 1980 1:00:00 GMT" />
        <meta httpEquiv="pragma" content="no-cache" />
      </Helmet>
      <>
        {!initialLoadUserDone ? (
          <LoadingIndicator />
        ) : (
          <Switch>
            <Route
              exact
              path={`${BASE_DIRECTORY}/logout`}
              component={Signing}
            />
            <Route exact path={`${BASE_DIRECTORY}/login`} component={Signing} />
            <Route
              exact
              path={`${BASE_DIRECTORY}/partner/login`}
              component={PartnerLogin}
            />
            <Route
              exact
              path={`${BASE_DIRECTORY}/forgot-password`}
              component={ForgotPassword}
            />
            <Route
              exact
              path="/reset-password/:token"
              component={ResetPassword}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/`}
              component={Dashboard}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/admin`}
              component={Admin}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/admin/:tabId`}
              component={Admin}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/admin/:tabId/:folderId`}
              component={Admin}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company`}
              component={Company}
            />
            {/* <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/add`}
              component={CreateCompany}
            /> */}
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/add/:id`}
              component={CreateCompany}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/edit/:id`}
              component={EditCompany}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/:companyId/preview`}
              component={PartnerPreview}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/cloud`}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/contract`}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/cloud/:folderId`}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/profile`}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/about`}
              component={Company}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company/partner`}
              component={Company}
            />
            {/* <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts`}
              component={Posts}
            /> */}
            <Route exact path={`${BASE_DIRECTORY}/posts`}>
              <Redirect to={`${BASE_DIRECTORY}/posts/architectures`} />
            </Route>
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId`}
              component={Posts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId/filter/:pageNumber`}
              component={Posts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId/filter/:pageNumber/:status`}
              component={Posts}
            />
            <Route exact path={`${BASE_DIRECTORY}/information-posts`}>
              <Redirect to={`${BASE_DIRECTORY}/information-posts/catalogues`} />
            </Route>
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/information-posts/:pageId`}
              component={Posts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId/add`}
              component={CreatePost}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:pageId/add/:postId`}
              component={EditPost}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:postId/preview`}
              component={PreviewPost}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/posts/:competitionId/:pageId`}
              component={Posts}
            />
            <PrivateRoute exact path="/page" component={Pages} />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/categories/posts`}
              component={PostCategories}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/categories/information`}
              component={InformationCategories}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/categories/company`}
              component={CompanyCategories}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/fav-posts`}
              component={ReaderPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/fav-information-posts`}
              component={ReaderPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/fav-company`}
              component={ReaderCompany}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/overview`}
              component={Overview}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/overview/:companyId`}
              component={Overview}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company-posts/:companyId`}
              component={CompanyPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company-posts`}
              component={CompanyPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/post/view/:postId`}
              component={PostView}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company-information`}
              component={CompanyPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/company-information/:companyId`}
              component={CompanyPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/cloud`}
              component={Files}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/cloud/:companyId`}
              component={Files}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/account/:companyId`}
              component={Account}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/account`}
              component={Account}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/partners`}
              component={PartnerPage}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/readers`}
              component={Readers}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/seller`}
              component={Seller}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/import-posts`}
              component={ImportPosts}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/judge`}
              component={JudgePage}
            />{' '}
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/judge/:tab`}
              component={JudgePage}
            />
            <PrivateRoute
              exact
              path={`${BASE_DIRECTORY}/editors`}
              component={Editor}
            />
            {/* <Route exact path={judgePath}> */}
            {/*  <JudgePage /> */}
            {/* </Route> */}
            {/* <Route path={`${judgePath}/:tab`}> */}
            {/*  <JudgePage /> */}
            {/* </Route> */}
            {/* <Route path={`${judgePath}/time`}> */}
            {/*  <Time /> */}
            {/* </Route> */}
            {/* <Route path={`${judgePath}/award`}> */}
            {/*  <Award /> */}
            {/* </Route> */}
            {/* <Route path={`${judgePath}/candidate`}> */}
            {/*  <Candidate /> */}
            {/* </Route> */}
            <Route component={NotFoundPage} />
          </Switch>
        )}
      </>
    </div>
  );
}
